import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { validateNumber } from "../Utils/validation";

function TechBridgeCount(props) {
  const { CountList } = props;

  return (
    <div className="Dashboard  row-count">
      {CountList.map((a, i) => {
        return (
          <div className="mt-2 col-count" key={i}>
            <div className="box-count">
              <div>
                <div className="dash-detail">
                  <span className="f-16">{a.title}</span>
                  <br></br>
                  <span className="text-bold">
                    {a.title === "Total Time Spent" ? (
                      `${
                        validateNumber(a.list)
                          ? a.list || 0
                          : a.list?.toFixed(2) || 0
                      }Hrs`
                    ) : (
                      <CountUp end={a.list} duration={3} />
                    )}
                  </span>
                </div>
                {/* {true ? (
                  <>
                    <img src={up} width={15} />
                    <small className="c-green"> +0.00.</small>
                  </>
                ) : (
                  <>
                    <img src={down} />
                    <small className="c-red"> +0.00%.</small>
                  </>
                )}
                <small> vs Previous month</small> */}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(TechBridgeCount);
